import React from 'react';
import { connect } from 'react-redux';
import { MessageBar, MessageBarType } from '@fluentui/react';

class InfoTable extends React.Component {

    convertQuota(q) {
        if (q != null) {
            const qString = q < 1000 ? `${q} GB` : `${Math.round(q/1000)} TB`;
            return qString;
        }
    }

    render() {

        return (
            this.props.onlineLocation !== null &&
                <div style={tableStyle}>
                    <MessageBar messageBarType={MessageBarType.info}>
                        <div>You are going to create: {this.props.locationObject.name} Site</div>
                        <div>Default quota: {this.convertQuota(this.props.quota)}</div>
                        <div>{this.props.locationObject.remarks}</div>
                    </MessageBar>
                </div>
                
        );
    }

}

const tableStyle = {
    margin: '10px 0'
}

const mapStateToProps = state => ({
    onlineLocation: state.newSite.OnlineLocation,
    quota: state.newSite.QuotaSize,
    locationObject : state.newSite.Location
});


export default connect(mapStateToProps, null)(InfoTable);


// WEBPACK FOOTER //
// ./src/components/CreateSite/Step1/InfoTable.js